/* */ 
'use strict';
var $at = require('./_string-at')(true);
require('./_iter-define')(String, 'String', function(iterated) {
  this._t = String(iterated);
  this._i = 0;
}, function() {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length)
    return {
      value: undefined,
      done: true
    };
  point = $at(O, index);
  this._i += point.length;
  return {
    value: point,
    done: false
  };
});
